import React, { useState, useEffect } from "react";
//Bootstrap
import PotentialExpensesTableRows from "./PotentialExpensesTableRows";
//Components
import TableHead from "../TableHead/TableHead";

export default function PotentialExpensesTable({
  potentialExpenses,
  setPotentialExpenses,
  potentialExpenseRows,
  setPotentialExpenseRows,
  tableHeads,
  deleteMonth,
}) {
  const [showPotentialExpenses, setShowPotentialExpenses] = useState(true);

  useEffect(() => {
    var month1 = 0;
    var month2 = 0;
    var month3 = 0;
    var month4 = 0;
    var month5 = 0;
    var month6 = 0;
    var month7 = 0;
    var month8 = 0;
    var month9 = 0;
    var month10 = 0;
    var month11 = 0;
    var month12 = 0;
    potentialExpenseRows.map((row) => {
      month1 += Number(row.potentialExpenseOne);
      month2 += Number(row.potentialExpenseTwo);
      month3 += Number(row.potentialExpenseThree);
      month4 += Number(row.potentialExpenseFour);
      month5 += Number(row.potentialExpenseFive);
      month6 += Number(row.potentialExpenseSix);
      month7 += Number(row.potentialExpenseSeven);
      month8 += Number(row.potentialExpenseEight);
      month9 += Number(row.potentialExpenseNine);
      month10 += Number(row.potentialExpenseTen);
      month11 += Number(row.potentialExpenseEleven);
      month12 += Number(row.potentialExpenseTwelve);
    });
    setPotentialExpenses({
      month1: month1,
      month2: month2,
      month3: month3,
      month4: month4,
      month5: month5,
      month6: month6,
      month7: month7,
      month8: month8,
      month9: month9,
      month10: month10,
      month11: month11,
      month12: month12,
    });
  }, [potentialExpenseRows]);

  const addRow = (id, details) => {
    const randomId = (Math.random() + 1).toString(36).substring(7);

    var newest;
    newest = potentialExpenseRows.slice(-1)[0];
    if (details) {
      //then create a blank new row
      if (id === "0z123") {
        if (potentialExpenseRows.length) {
        } else {
          const newEntry = {
            id: id,
          };
          setPotentialExpenseRows((prev) => {
            return [...prev, newEntry];
          });
        }
      }
    }

    if (!details) {
      //then create a blank new row
      if (id === newest.id) {
        const newEntry = {
          id: randomId,
          potentialExpenseOne: 0,
          potentialExpenseTwo: 0,
          potentialExpenseThree: 0,
          potentialExpenseFour: 0,
          potentialExpenseFive: 0,
          potentialExpenseSix: 0,
          potentialExpenseSeven: 0,
          potentialExpenseEight: 0,
          potentialExpenseNine: 0,
          potentialExpenseTen: 0,
          potentialExpenseEleven: 0,
          potentialExpenseTwelve: 0,
        };
        setPotentialExpenseRows((prev) => {
          return [...prev, newEntry];
        });
      }
    }
  };

  const removeRow = (id) => {
    if (potentialExpenseRows.length !== 1) {
      setPotentialExpenseRows((prev) => {
        return prev.filter((row) => {
          return row.id !== id;
        });
      });
    }
  };

  const setField = (field, id, value) => {
    let current = potentialExpenseRows.find((row) => row.id === id);

    if (current) {
      current[field] = value;

      setPotentialExpenseRows([...potentialExpenseRows]);
    } else {
      const row = {
        [field]: value,
        id: id,
      };
      setPotentialExpenseRows([...potentialExpenseRows, { row }]);
    }
  };

  const updateShow = () => {
    setShowPotentialExpenses(!showPotentialExpenses);
  };

  return (
    <div>
      <table className="expensesTable">
        <thead className="expensesTableheadborder">
          <TableHead
            header={"Potential Expenses"}
            tableHeads={tableHeads}
            deleteMonth={deleteMonth}
            updateShow={updateShow}
            show={showPotentialExpenses}
          />
        </thead>
        <tbody className="">
          {showPotentialExpenses &&
            potentialExpenseRows.map((row) => (
              <PotentialExpensesTableRows
                id={row.id}
                key={row.id}
                row={row}
                addRow={addRow}
                removeRow={removeRow}
                setField={setField}
                potentialExpenseRows={potentialExpenseRows}
              />
            ))}
        </tbody>
        <tfoot className="foot expensesFoot">
          <tr>
            <td></td>
            <td>{potentialExpenses.month1}</td>
            <td>{potentialExpenses.month2}</td>
            <td>{potentialExpenses.month3}</td>
            <td>{potentialExpenses.month4}</td>
            <td>{potentialExpenses.month5}</td>
            <td>{potentialExpenses.month6}</td>
            <td>{potentialExpenses.month7}</td>
            <td>{potentialExpenses.month8}</td>
            <td>{potentialExpenses.month9}</td>
            <td>{potentialExpenses.month10}</td>
            <td>{potentialExpenses.month11}</td>
            <td>{potentialExpenses.month12}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
